module.exports = __webpack_public_path__ + "img/account-statement.55baeb8e.svg";